// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__22ncG","subheader":"ReorderModal_subheader__1ZaVX","listWrap":"ReorderModal_listWrap__1GGQN"};